import { getLodop } from "@/common/LodopFuncs"
import utils from '@/common/utils'
const print = {
  // 门诊日结单
  settle: function (data) {
    const LODOP = getLodop()
    if (!LODOP) {
      return;
    }
    LODOP.PRINT_INITA(0, 0, 780, 1100, "日结单打印");
    LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4') // 设定纸张大小

    LODOP.ADD_PRINT_TEXT(35, 40, 720, 35, "门诊收费员日结表");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.ADD_PRINT_LINE(70, 30, 70, 740, 0, 1); // 下

    LODOP.ADD_PRINT_TEXT(80, 40, 150, 25, "收费员");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_TEXT(80, 230, 500, 25, data.username);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_LINE(105, 30, 105, 740, 0, 1); //下


    LODOP.ADD_PRINT_TEXT(115, 40, 150, 25, "收款日期");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_TEXT(115, 230, 500, 25, data.accountDate);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_LINE(140, 30, 140, 740, 0, 1); //下

    LODOP.ADD_PRINT_TEXT(145, 30, 150, 25, "项目名称");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.ADD_PRINT_TEXT(145, 230, 90, 25, "金额");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.ADD_PRINT_LINE(140, 340, 170, 340, 0, 1); //右
    LODOP.ADD_PRINT_TEXT(145, 400, 130, 25, "项目名称");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.ADD_PRINT_LINE(140, 600, 170, 600, 0, 1); //右
    LODOP.ADD_PRINT_TEXT(145, 630, 90, 25, "金额");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.ADD_PRINT_LINE(170, 30, 170, 740, 0, 1); //下
    var count = Math.ceil(data.info.length / 2);
    var top = 0;
    for (let index = 0; index < count; index++) {
      top = index * 35;
      LODOP.ADD_PRINT_TEXT(180 + top, 40, 137, 20, utils.dictText(data.info[index * 2].type, 'FeeType'));
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
      LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
      LODOP.ADD_PRINT_TEXT(180 + top, 230, 90, 25, data.info[index * 2].amount);
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
      LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
      LODOP.ADD_PRINT_LINE(170 + top, 340, 205 + top, 340, 0, 1); //第二列右
      LODOP.ADD_PRINT_LINE(170 + top, 600, 205 + top, 600, 0, 1); //第三列右
      if (data.info.length - 1 >= index * 2 + 1) {
        LODOP.ADD_PRINT_TEXT(180 + top, 350, 230, 25, utils.dictText(data.info[index * 2 + 1].type, 'FeeType'));
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        LODOP.ADD_PRINT_TEXT(180 + top, 630, 90, 25, data.info[index * 2 + 1].amount);
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
      }
      LODOP.ADD_PRINT_LINE(205 + top, 30, 205 + top, 740, 0, 1); //下
    }

    LODOP.ADD_PRINT_TEXT(215 + top, 40, 150, 25, "划价合计");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_TEXT(215 + top, 230, 500, 25, data.total);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_LINE(242 + top, 30, 242 + top, 740, 0, 1); //下

    LODOP.ADD_PRINT_TEXT(255 + top, 40, 150, 25, "大写金额");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_LINE(70, 200, 280 + top, 200, 0, 1); //第一列右
    LODOP.ADD_PRINT_TEXT(255 + top, 210, 400, 25, data.bigTotal);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_LINE(280 + top, 30, 280 + top, 740, 0, 1); //下


    if (data.dataByPay && data.dataByPay.length) {
      var line = Math.ceil(data.dataByPay.length / 4);
      for (let i = 0; i < line; i++) {
        LODOP.ADD_PRINT_LINE(280 + top + i * 35, 200, 345 + top + i * 60, 200, 0, 1); //右
        LODOP.ADD_PRINT_LINE(280 + top + i * 35, 400, 345 + top + i * 60, 400, 0, 1); //右
        LODOP.ADD_PRINT_LINE(280 + top + i * 35, 570, 345 + top + i * 60, 570, 0, 1); //右
        LODOP.ADD_PRINT_LINE(345 + top + (i * 2 - 1) * 30, 30, 345 + top + (i * 2 - 1) * 30, 740, 0, 1); //下
        LODOP.ADD_PRINT_LINE(345 + top + i * 60, 30, 345 + top + i * 60, 740, 0, 1); //下
      }
      var col = 0;
      var k = 1;
      data.dataByPay.forEach(val => {
        LODOP.ADD_PRINT_TEXT(290 + top, 40 + (190 * col), 150, 25, utils.dictText(val.type, 'PayWay'));
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        LODOP.ADD_PRINT_TEXT(320 + top, 40 + (190 * col), 150, 25, val.amount);
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        if (col == 3 && k < line) {
          top += 60;
          col = -1;
          k++;
        }
        col++;
      })
    } else {
      top -= 65;
    }

    LODOP.ADD_PRINT_TEXT(355 + top, 40, 500, 80, "发票号：" + data.note);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.ADD_PRINT_LINE(345 + top, 570, 380 + top, 570, 0, 1); //右
    LODOP.ADD_PRINT_TEXT(355 + top, 580, 150, 30, "共" + data.noteCount + "张");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    if (data.note && data.note.length > 50) {
      LODOP.ADD_PRINT_LINE(380 + top, 570, 380 + top + 30, 570, 0, 1); //右
      top += 30;
    }
    LODOP.ADD_PRINT_LINE(380 + top, 30, 380 + top, 740, 0, 1);

    LODOP.ADD_PRINT_TEXT(390 + top, 40, 150, 30, "作废发票");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_LINE(380 + top, 200, 445 + top, 200, 0, 1);
    LODOP.ADD_PRINT_TEXT(390 + top, 230, 500, 25, "张数：" + data.invalidTicketCount + "张，作废金额：" + data.invalidTicketMoney);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_LINE(412 + top, 200, 412 + top, 740, 0, 1); //下

    LODOP.ADD_PRINT_TEXT(423 + top, 210, 520, 110, data.invalidTicket);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    if (data.invalidTicket && data.invalidTicket.length > 50) {
      LODOP.ADD_PRINT_LINE(445 + top, 200, 445 + top + 30, 200, 0, 1);
      top += 30;
    }

    LODOP.ADD_PRINT_TEXT(455 + top, 40, 240, 30, "制表：" + data.lister);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.ADD_PRINT_TEXT(455 + top, 270, 240, 30, "审核：");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.ADD_PRINT_TEXT(455 + top, 440, 300, 30, "制表日期：" + data.time);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);

    // 最外面线
    LODOP.ADD_PRINT_LINE(25, 30, 25, 741, 0, 1); // 上
    LODOP.ADD_PRINT_LINE(445 + top, 30, 445 + top, 740, 0, 1);//下
    LODOP.ADD_PRINT_LINE(25, 30, 445 + top, 30, 0, 1); // 左
    LODOP.ADD_PRINT_LINE(25, 740, 445 + top, 740, 0, 1); // 右
    if (localStorage.getItem('printerConfig')) {
      const printerConfig = JSON.parse(localStorage.getItem('printerConfig'));
      if (printerConfig && printerConfig.dayendPrinter) {
        LODOP.SET_PRINTER_INDEX(printerConfig.dayendPrinter);
      }
    }
    LODOP.PREVIEW() // 打印预览
    // LODOP.PRINT_DESIGN // 打印设计
  },
  // 挂号凭证
  regVoucher: function (reg, payment) {
    const LODOP = getLodop()
    if (!LODOP) {
      return;
    }
    LODOP.PRINT_INITA(0, 0, 800, 1400, "挂号凭证");
    LODOP.SET_PRINT_PAGESIZE(3, 800, 10, '') // 设定纸张大小8cm*14cm
    LODOP.ADD_PRINT_RECT(15, 15, 275, 500, 0, 1);
    LODOP.ADD_PRINT_TEXT(25, 20, 270, 30, "明医（广州）医院挂号单");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    LODOP.ADD_PRINT_LINE(55, 15, 55, 290, 0, 1);
    LODOP.ADD_PRINT_TEXT(65, 20, 250, 25, "姓    名：" + reg.patientName);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(90, 20, 250, 25, "卡    号：" + (reg.cardNo || ''));
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(115, 20, 250, 25, "凭 条 号：" + reg.opNo);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(140, 20, 250, 25, "支付方式：" + payment.paymentType || '');
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(165, 20, 250, 25, "就诊类型：" + reg.opType);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(190, 20, 250, 25, "医 师 名：" + reg.doctorName);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(215, 20, 250, 25, "就诊序号：" + reg.seqNo);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(240, 20, 250, 25, "挂 号 员：" + (reg.registrarName || ''));
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(265, 20, 250, 25, "就 诊日 期：" + reg.date);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.ADD_PRINT_TEXT(290, 20, 250, 25, "挂号流水号：" + reg.opNo);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.ADD_PRINT_TEXT(315, 20, 250, 25, "就诊时间段：" + `${reg.periodStart} - ${reg.periodEnd}`);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.ADD_PRINT_TEXT(340, 20, 250, 24, "诊  疗  费：" + utils.fmtFloat(payment.amount || reg.pay, 2));
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.ADD_PRINT_TEXT(365, 20, 120, 45, "就 诊地 址：");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.ADD_PRINT_TEXT(365, 115, 150, 45, reg.deptName);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
    LODOP.ADD_PRINT_LINE(415, 15, 415, 290, 0, 1);
    const date = new Date()
    const year = date.getFullYear()
    const month = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1)
    const day = (date.getDate() < 10 ? '0' : '') + date.getDate()
    const hours = (date.getHours() < 10 ? '0' : '') + date.getHours()
    const minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
    const seconds = (date.getSeconds() < 10 ? '0' : '') + date.getSeconds()
    const now = year + '-' + month + '-' + day + '  ' + hours + ':' + minutes + ':' + seconds
    LODOP.ADD_PRINT_TEXT(430, 20, 250, 25, "打印时间：" + now);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    LODOP.ADD_PRINT_TEXT(455, 20, 250, 24, "温馨提示：");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    LODOP.ADD_PRINT_TEXT(475, 30, 250, 24, "1.号源当班有效，过时号源不退号不退费");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    LODOP.ADD_PRINT_TEXT(495, 30, 250, 24, "2.此凭证不作为报销凭据。");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    if (localStorage.getItem('printerConfig')) {
      const printerConfig = JSON.parse(localStorage.getItem('printerConfig'));
      if (printerConfig && printerConfig.registeredPrintVoucher) {
        LODOP.SET_PRINTER_INDEX(printerConfig.registeredPrintVoucher);
      }
    }
    LODOP.PREVIEW() // 打印预览
    // LODOP.PRINT() // 打印
    // LODOP.PRINT_DESIGN() // 打印设计
  },
  // 收费凭证
  chargeVoucher: function (data) {
    const LODOP = getLodop()
    if (!LODOP) {
      return;
    }
    LODOP.PRINT_INITA(0, 0, 800, 1500, "挂号凭证");
    LODOP.SET_PRINT_PAGESIZE(3, 800, 10, '') // 设定纸张大小8cm*
    // LODOP.ADD_PRINT_RECT(15,15,275,500,0,1);
    LODOP.ADD_PRINT_TEXT(25, 0, 300, 30, "明医（广州）医院收费凭条");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 17);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    // LODOP.ADD_PRINT_LINE(55,10,55,290,0,1);
    LODOP.ADD_PRINT_TEXT(65, 10, 250, 25, "姓    名：" + data.patientName);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(90, 10, 250, 25, "卡    号：" + data.cardNo);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(115, 10, 250, 25, "凭 条 号：" + data.no);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(140, 10, 250, 25, "挂号流水：" + (data.opNo || ''));
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(165, 10, 250, 25, "患者类型：" + (data.opType || ''));
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(190, 10, 250, 25, "支付方式：" + data.paymentType || '');
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(215, 10, 250, 25, "费用合计：" + data.amount);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(240, 10, 250, 25, "个人支付：" + data.payment);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(265, 10, 250, 25, "基金支付：" + data.accountPayments);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_TEXT(290, 10, 250, 25, "医保内：" + data.insurance);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.ADD_PRINT_LINE(320, 10, 320, 290, 3, 0);
    LODOP.ADD_PRINT_LINE(337, 10, 337, 118, 3, 0);
    LODOP.ADD_PRINT_LINE(337, 180, 337, 290, 3, 0);

    LODOP.ADD_PRINT_TEXT(330, 120, 100, 25, "费用明细");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 11);
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.ADD_PRINT_TEXT(360, 10, 100, 25, "项目名称");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.ADD_PRINT_TEXT(360, 120, 100, 25, "规格");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.ADD_PRINT_TEXT(360, 170, 100, 25, "单价");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.ADD_PRINT_TEXT(360, 220, 100, 25, "数量");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.ADD_PRINT_TEXT(360, 260, 100, 25, "金额");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

    let top = 0
    if (data.reg) {
      LODOP.ADD_PRINT_TEXT(385 + top, 10, 100, 25, "医事服务费");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.ADD_PRINT_TEXT(385 + top, 120, 100, 25, "");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.ADD_PRINT_TEXT(385 + top, 170, 30, 25, (data.reg.pay || 0));
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
      LODOP.ADD_PRINT_TEXT(385 + top, 220, 30, 25, "1次");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
      LODOP.ADD_PRINT_TEXT(385 + top, 260, 100, 25, utils.fmtFloat((data.reg.pay || 0), 2));
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      top += 20
    }
    data.items.forEach(element => {
      LODOP.ADD_PRINT_TEXT(385 + top, 10, 200, 60, element.name);
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.ADD_PRINT_TEXT(385 + top, 120, 70, 50, element.standard);
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.ADD_PRINT_TEXT(385 + top, 170, 40, 25, element.price);
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
      LODOP.ADD_PRINT_TEXT(385 + top, 210, 40, 25, (element.quantity * element.rpQuantity) + (element.unit || '次'));
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
      LODOP.ADD_PRINT_TEXT(385 + top, 260, 100, 25, utils.fmtFloat(element.price * element.quantity * element.rpQuantity, 2));
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      // top += element.name.length > 8 || (element.standard ? element.standard.length : 0) > 8 ? 40 : 20
      let c = Math.ceil(element.name.length / 8)
      let c2 = Math.ceil((element.standard ? element.standard.length : 0) / 8)
      top += (c >= c2 ? c : c2) * 20
    });
    LODOP.ADD_PRINT_LINE(400 + top, 10, 400 + top, 290, 3, 0);
    LODOP.ADD_PRINT_TEXT(420 + top, 10, 250, 25, "打印时间：" + utils.fmtDateTime(utils.serverTime));
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
    // LODOP.ADD_PRINT_TEXT(445 + top,10,250,24,"注意事项：");
    // LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
    // LODOP.ADD_PRINT_TEXT(465 + top,20,250,24,"1.XXXXXXXXXXXXXXXXX");
    // LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
    // LODOP.ADD_PRINT_TEXT(485 + top,20,250,24,"2.XXXXXXXXXXXXXXXXX。");
    // LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
    if (localStorage.getItem('printerConfig')) {
      const printerConfig = JSON.parse(localStorage.getItem('printerConfig'));
      if (printerConfig && printerConfig.tollVoucher) {
        LODOP.SET_PRINTER_INDEX(printerConfig.tollVoucher);
      }
    }
    LODOP.PREVIEW() // 打印预览
    // LODOP.PRINT() // 打印
    // LODOP.PRINT_DESIGN() // 打印设计
  },
  /***************  模板打印 ***************/
  // 收费凭证
  chargeReceipt: function (data, template) {
    let LODOP = getLodop();
    if (!LODOP) {
      return;
    }
    eval(template);
    LODOP.SET_PRINT_PAGESIZE(3, 800, 10, '') // 设定纸张大小8cm*
    Object.entries(data).forEach(([item, value]) => {
      LODOP.SET_PRINT_STYLEA(item, 'CONTENT', value);
    });
    let top = 0
    if (data.reg) {
      LODOP.ADD_PRINT_TEXT(425 + top, 5, 100, 25, "医事服务费");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.ADD_PRINT_TEXT(425 + top, 120, 100, 25, "");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.ADD_PRINT_TEXT(425 + top, 120, 50, 25, (data.reg.pay || 0));
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
      LODOP.ADD_PRINT_TEXT(425 + top, 180, 30, 25, "1次");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
      LODOP.ADD_PRINT_TEXT(425 + top, 240, 100, 25, utils.fmtFloat((data.reg.pay || 0), 2));
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      top += 20
    }
    // 0812优化
    data.items.forEach(element => {
      const { standard, price, quantity, rpQuantity } = element;
      const name = element.name + ((standard && standard !== '-') ? `_${standard}` : '');
      LODOP.ADD_PRINT_TEXT(425 + top, 5, 145, 50, name);
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.ADD_PRINT_TEXT(425 + top, 140, 50, 25, price);
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      const str = (rpQuantity && rpQuantity > 1) ? (rpQuantity + '*') : '';
      LODOP.ADD_PRINT_TEXT(425 + top, 174, 50, 25, str + quantity + (element.unit || '次'));
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
      const money = rpQuantity ? (price * quantity * rpQuantity) : (price * quantity);
      LODOP.ADD_PRINT_TEXT(425 + top, 235, 100, 25, utils.fmtFloat(money, 2));
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
      let c = Math.ceil(name.length / 12);
      top += c * 20
    });
    // 0802之前
    // data.items.forEach(element => {
    //   const name = element.name + '_' + (element.standard || '')
    //   LODOP.ADD_PRINT_TEXT(425 + top, 5, 145, 50, name);
    //   LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
    //   LODOP.ADD_PRINT_TEXT(425 + top, 140, 50, 25, element.price);
    //   LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
    //   const str = element.rpQuantity > 1 ? (element.rpQuantity + '*') : ''
    //   LODOP.ADD_PRINT_TEXT(425 + top, 174, 50, 25, str + element.quantity + (element.unit || '次'));
    //   LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
    //   LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
    //   LODOP.ADD_PRINT_TEXT(425 + top, 235, 100, 25, utils.fmtFloat(element.price * element.quantity * element.rpQuantity, 2));
    //   LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
    //   let c = Math.ceil(name.length / 12)
    //   top += c * 20
    // });
    LODOP.ADD_PRINT_BARCODE(440 + top, 25, 250, 40, '128B', data.opNo);
    LODOP.ADD_PRINT_LINE(500 + top, 10, 500 + top, 270, 3, 0);
    LODOP.ADD_PRINT_TEXT(515 + top, 5, 250, 50, "收 费 员：" + data.operatorUserId);
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
    LODOP.ADD_PRINT_TEXT(540 + top, 5, 300, 50, "打印时间：" + utils.fmtDateTime(utils.serverTime));
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 13);
    if (localStorage.getItem('printerConfig')) {
      const printerConfig = JSON.parse(localStorage.getItem('printerConfig'));
      if (printerConfig && printerConfig.tollVoucher) {
        LODOP.SET_PRINTER_INDEX(printerConfig.tollVoucher);
      }
    }
    // LODOP.PREVIEW();
    LODOP.PRINT();
  },
  // 结算单打印
  statementTable: function (strHtml) {
    const LODOP = getLodop()
    if (!LODOP) {
      return;
    }
    LODOP.PRINT_INITA(0, 0, 780, 1100, "结算单打印");
    LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4') // 设定纸张大小
    LODOP.ADD_PRINT_TABLE(0,0,'100%','100%',strHtml)

    LODOP.PREVIEW();
  }
}
export default print
